import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import useAxios from './useAxios';

export interface WelcomePurchasesTimeStats {
    purchases1h: number;
    revenue1h: number;

    purchases12h: number;
    revenue12h: number;

    purchases24h: number;
    revenue24h: number;

    purchases1w: number;
    revenue1w: number;

    purchases1m: number;
    revenue1m: number;
}

const useMessageUsersAutoWelcomeMessageOnlineUsersSalesStats = () => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const params = useParams();
    const axios = useAxios();

    const fetchData = async (): Promise<WelcomePurchasesTimeStats> => {
        if (userContext.jwtToken && settingsContext.apiKey && 'userId' in params && params.userId) {
            const query: string = `${settingsContext.routes.messageUsers.base}${params.userId}/autoWelcomeMessagesOnlineUsers/sales/stats`;

            return axios
                .get(query)
                .then(async response => {
                    if (response.status === 200) {
                        return response.data;
                    }

                    return {
                        purchases1h: 0,
                        revenue1h: 0,
                        purchases12h: 0,
                        revenue12h: 0,
                        purchases24h: 0,
                        revenue24h: 0,
                        purchases1w: 0,
                        revenue1w: 0,
                        purchases1m: 0,
                        revenue1m: 0,
                    };
                })
                .catch(error => {
                    console.error(error);

                    return {
                        purchases1h: 0,
                        revenue1h: 0,
                        purchases12h: 0,
                        revenue12h: 0,
                        purchases24h: 0,
                        revenue24h: 0,
                        purchases1w: 0,
                        revenue1w: 0,
                        purchases1m: 0,
                        revenue1m: 0,
                    };
                });
        }

        return {
            purchases1h: 0,
            revenue1h: 0,
            purchases12h: 0,
            revenue12h: 0,
            purchases24h: 0,
            revenue24h: 0,
            purchases1w: 0,
            revenue1w: 0,
            purchases1m: 0,
            revenue1m: 0,
        };
    };

    return useQuery(['messageUsersAutoWelcomeMessageOnlineUsersSalesStats', params.userId], () => fetchData(), {
        refetchOnWindowFocus: false,
        // Stale time 5 minutes
        staleTime: 300000,
        refetchInterval: 300000,
        enabled: userContext.jwtToken && settingsContext.apiKey && params.userId ? true : false,
    });
};

export default useMessageUsersAutoWelcomeMessageOnlineUsersSalesStats;
